export const environment = {
  production: true,
  protocol: 'http',
  domain: 'localhost',
  port: '9000',
  apiPath: '/api/v1',
  shelterId: '23718905-8bf3-444e-b2ec-28f8660594db'
};
